import { QueryKey } from "@tanstack/react-query";
import { atom } from "jotai";

export const mediaElementAtom = atom<HTMLMediaElement | null>(null);

export const currentTimeAtom = atom<number>(0);

export const activeWaveformQueryKeyAtom = atom<{ queryKey: QueryKey }>({
  queryKey: [],
});
